<template>
    <div class="app-container py-4">
        <div
            v-if="isUserLoggedIn"
            class="profile-personal profile-inner-page px-0 px-sm-4"
        >
            <v-row class="mx-0">
                <v-col cols="12" md="4" class="hidden-sm-and-down pr-0">
                    <profile-menu @logout="logout" :active-link="3"></profile-menu>
                </v-col>
                <v-col cols="12" md="8">
                    <v-card outlined class="profile-card mb-2 mb-md-6 border-transparent">
                        <v-card-title class="text-uppercase justify-center">{{ $t('commercialPolicy') }}</v-card-title>
                    </v-card>
                    <v-card class="pa-0 border-transparent" outlined>
                        <v-tabs v-model="tab" background-color="main--yellow" dark fixed-tabs>
                            <v-tab
                                    v-for="tab in tabs"
                                    :key="tab.title"
                                    class="body-2 text-capitalize"
                            >{{ tab.title }}</v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab" next-icon prev-icon>

                            <v-tab-item v-for="tab in tabs" :key="tab.title" v-if="tab.type === typePurchaseAmount">
                                <v-col cols="12" sm="12" class="py-0">
                                    <purchase-amount
                                            @list-change="amountPolicyChange"
                                            :initial-amount-policy="initialAmountPolicy"
                                            :currencies-data="currencies"
                                    ></purchase-amount>
                                </v-col>
                            </v-tab-item>

                            <v-tab-item v-for="tab in tabs" :key="tab.title" v-if="tab.type === typePayment">
                                <v-col cols="12" sm="12" class="py-0">
                                    <v-card flat>
                                        <payment
                                                @list-change="paymentPolicyChange"
                                                @checkbox-change="paymentPolicyPrepaymentChange"
                                                :initial-payment-policy="initialPaymentPolicy"
                                                :guarantee-data="guaranties"
                                        ></payment>
                                    </v-card>
                                </v-col>
                            </v-tab-item>

                            <v-tab-item v-for="tab in tabs" :key="tab.title" v-if="tab.type === typeOrderDate">
                                <v-col cols="12" sm="12" class="py-0">
                                    <v-card flat>
                                        <order-date
                                                @list-change="datePolicyChange"
                                                :initial-date-policy="initialDatePolicy"
                                        ></order-date>
                                    </v-card>
                                </v-col>
                            </v-tab-item>

                        </v-tabs-items>
                    </v-card>
                    <div class="pt-4 d-flex justify-end">
                        <v-btn dark color="main--yellow" @click="saveData" id="save-btn" :disabled="!valid">{{ $t('save') }}</v-btn>
                    </div>
                </v-col>
            </v-row>
            <snack-general :snack-data="snackData"></snack-general>
        </div>
    </div>
</template>

<script>

    import AppSnack from '../../../../general/mixins/AppSnack';
    import CommercialPolicyService from '../../../../app-front/services/api/CommercialPolicyService';
    import ProfileMenu from '../../../../app-front/components/profile/menu';
    import OrderDate from './OrderDate';
    import Payment from './Payment';
    import PurchaseAmount from './PurchaseAmount';
    import SnackGeneral from '../../../../app-front/components/snacks/SnackGeneral';
    import WatchLogoutRedirect from '../../../../app-front/mixins/WatchLogoutRedirect';

    export default {
        name: "CommercialPolicy",
        mixins: [
            AppSnack,
            WatchLogoutRedirect,
        ],
        components: {ProfileMenu, PurchaseAmount, Payment, OrderDate, SnackGeneral},
        data() {
            return {
                validated: false,
                tab: null,
                typePurchaseAmount: 'purchaseAmount',
                typePayment: 'payment',
                typeOrderDate: 'orderDate',
                tabs: [
                    { title: this.$t('purchaseAmount'), type: 'purchaseAmount' },
                    { title: this.$t('payment'), type: 'payment' },
                    { title: this.$t('orderDate'),type: 'orderDate' },
                ],
                paymentTabContent: null,
                amountPolicy: [],
                initialAmountPolicy: [],
                paymentPolicy: {
                    prepayment: {},
                    credits: [],
                },
                initialPaymentPolicy: {},
                datePolicy: [],
                initialDatePolicy: [],
                valid: false,
                currencies: [],
                guaranties: [],
                snackData: {
                    isOpen: false,
                    color: '',
                    text: ''
                }
            }
        },
        methods: {
            datePolicyChange(policy) {
                if (policy.isValid) {
                    this.datePolicy = policy.data;
                } else {
                    this.datePolicy = [];
                }

                this.valid = policy.isValid;
            },
            paymentPolicyPrepaymentChange(policy) {
                if (policy.isValid) {
                    this.paymentPolicy.prepayment = policy.data;

                } else {
                    this.paymentPolicy.prepayment = {};
                }

                this.valid = policy.isValid;
            },
            paymentPolicyChange(policy) {
                if (policy.isValid) {
                    this.paymentPolicy.credits = policy.data;
                } else {
                    this.paymentPolicy.credits = [];
                }

                this.valid = policy.isValid;
            },
            amountPolicyChange(policy) {
                if (policy.isValid) {
                    this.amountPolicy = policy.data;
                } else {
                    this.amountPolicy = [];
                }

                this.valid = policy.isValid;
            },
            getDataGeneral() {
                CommercialPolicyService.getDataGeneral().
                then((response) => {
                    this.currencies = response.data.currencies;
                    this.guaranties = response.data.guaranties;
                }).catch(err => {
                    console.log(err);
                });
            },
            getUserPolicies() {
                CommercialPolicyService.getDataProfile()
                    .then(res => {
                        this.amountPolicy = res.data.amountPolicy;
                        this.paymentPolicy = res.data.paymentPolicy;
                        this.datePolicy =res.data.datePolicy;

                        this.initialAmountPolicy = res.data.amountPolicy;
                        this.initialPaymentPolicy = res.data.paymentPolicy;
                        this.initialDatePolicy = res.data.datePolicy;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            saveData() {
                let data = {
                    amountPolicy: this.amountPolicy,
                    paymentPolicy: this.paymentPolicy,
                    datePolicy: this.datePolicy,
                };

                CommercialPolicyService.saveData(data)
                    .then(
                        this.snackHandle(this.$t('changesSaved'), 'main--black', true),
                        this.closeSnack()
                    )
                    .catch(err => {
                        this.snackHandle(this.$t('changesSavedError'), 'error', true);
                        console.log(err);
                    });
            },
            validate() {
                if(!this.valid) {
                    return false;
                }
                if(this.amountPolicy.length || this.datePolicy.length || this.paymentPolicy.credits.length || this.paymentPolicy.prepayment) {
                    this.valid = true;
                } else {
                    this.valid = false;
                }
            },
            snackHandle(text, color, isOpen) {
                this.snackData.color = color;
                this.snackData.text = text;
                this.snackData.isOpen = isOpen;
            },
        },
        watch: {
            amountPolicy: {
                handler() {
                    this.validate();
                },
                deep: true
            },
            paymentPolicy: {
                handler() {
                    this.validate();
                },
                deep: true
            },
            datePolicy: {
                handler() {
                    this.validate();
                },
                deep: true
            }
        },
        created() {
            this.getDataGeneral();
            this.getUserPolicies();
        }
    }
</script>

<style scoped>
    #save-btn.v-btn--disabled {
        background-color: #E0E0E0!important;
        color: #555!important;
    }
</style>
